export default __webpack_public_path__ + "static/media/overlaytwitter.215646aa.png";